import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Login from "../login";
import ChatbotList from "../chatbotList";
import ChatRoom from "../chatRoom";
import MapLocation from "@/components/MapLocation";
import WebContainer from "@/components/WebContainer";
import ClientEntry from "../clientEntry";
import ClientToLogin from "../clientEntry/toLogin";
import OpenByQuickapp from "../openByQuickapp";
import CpassChat from "../cpassChat/index.vue";
import NewChat from "../newChat/index.vue";
import SynagieChat from "../synagieChat/index.vue";
import SynagieChatNew from "../synagieChat/newIndex.vue";
import KnowledgeBaseH5 from "../knowledgeBase/index.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/hello",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/client",
      name: "client",
      component: ClientEntry
    },
    {
      path: "/clientToLogin",
      name: "clientToLogin",
      component: ClientToLogin
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/m/:templateId/:platformCode",
      name: "openMain",
      component: OpenByQuickapp
    },
    {
      path: "/m/:templateId",
      name: "openMain",
      component: OpenByQuickapp
    },
    {
      path: "/",
      name: "ChatbotList",
      component: ChatbotList
    },
    {
      path: "/chatRoom",
      name: "ChatRoom",
      component: ChatRoom
    },
    {
      path: "/web/:webUrl",
      name: "webContainer",
      component: WebContainer
    },
    {
      path: "/w",
      name: "openWeb",
      component: OpenByQuickapp
    },

    {
      path: "/map",
      name: "map",
      component: MapLocation
    },
    {
      path: "/heTuChatH5",
      meta: {
        title: 'iOne GPT'
      },
      name: 'heTuChatH5',
      component: CpassChat
    },
    {
      path: "/botChatH5",
      meta: {
        title: 'HETU GPT'
      },
      name: 'botChatH5',
      component: NewChat
    },
    {
      path: "/synagieChatH5",
      meta: {
        title: 'Synagie GPT'
      },
      name: 'synagieChat',
      component: SynagieChatNew
    },
    {
      path: "/synagieChatH5New",
      meta: {
        title: 'Synagie GPT'
      },
      name: 'synagieChatNew',
      component: SynagieChat
    },
    {
      path: "/knowledgeBaseH5",
      meta: {
        title: '知识库'
      },
      name: 'knowledgeBaseH5',
      component: KnowledgeBaseH5
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path !== "/heTuChatH5") {
    // 加载JS
    const script = document.createElement('script')
    script.src = 'https://api.map.baidu.com/api?v=3.0&ak=cdfNP7kMFcAzHXOTGj6pOZU530Fk0UXQ'
    document.body.appendChild(script)
  }
  document.title = to.meta.title || '5G消息助手';
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js